import { gwtClient } from "#/services/clients";
import { isEmpty, omit, reject } from "lodash";
import { type QueryKey, useMutation, useQuery } from "react-query";
import {
  type GetExamSummaryInfo,
  type GetMainResultSet,
} from "./multi-user.types";

export const getMainResultSet = {
  url: () => `/exam/getMainResultSet`,
  fn: async (request: GetMainResultSet["request"]) => {
    const { data } = await gwtClient<GetMainResultSet["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: getMainResultSet.url(),
      data: request.body,
    });
    return data;
  },
  key: (request: GetMainResultSet["request"]) => {
    return reject(
      [getMainResultSet.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty,
    ) as QueryKey;
  },
  query: (options: GetMainResultSet["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: getMainResultSet.key(options.request),
    queryFn: () => getMainResultSet.fn(options.request),
  }),
  useQuery: (options: GetMainResultSet["queryOptions"]) =>
    useQuery(getMainResultSet.query(options)),
  useMutation: (options?: GetMainResultSet["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getMainResultSet.fn,
    }),
};

export const getExamSummaryInfo = {
  url: () => `/exam/getExamSummaryInfo`,
  fn: async (request: GetExamSummaryInfo["request"]) => {
    const { data } = await gwtClient<GetExamSummaryInfo["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: getExamSummaryInfo.url(),
      data: request.body,
    });
    return data;
  },
  key: (request: GetExamSummaryInfo["request"]) => {
    return reject(
      [getExamSummaryInfo.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty,
    ) as QueryKey;
  },
  query: (options: GetExamSummaryInfo["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: getExamSummaryInfo.key(options.request),
    queryFn: () => getExamSummaryInfo.fn(options.request),
  }),
  useQuery: (options: GetExamSummaryInfo["queryOptions"]) =>
    useQuery(getExamSummaryInfo.query(options)),
  useMutation: (options?: GetExamSummaryInfo["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: getExamSummaryInfo.fn,
    }),
};
